import { escapeHtml } from "../../utils/common.js"
import { openUserPageOnClick } from "../pages/userpage.js"
import { isBlocked } from "../helpers/report.js"
import { el } from "redom";
import type { UserDetails } from "#/types.js";
import { Modal } from "bootstrap";

export const fillInUserListModal = (users: UserDetails[], modalId: string, modal: Modal) => {
    const list = document.getElementById("modal" + modalId + "Context")
    if (!list) return
    list.innerHTML = ""
    users.filter(u => !isBlocked(u.id)).forEach( user =>
        list.appendChild(
            el("h6", { style: "font-weight: 400; height: 30px;"},
                el(".clickable", { onclick: () => {
                    modal.hide();
                    openUserPageOnClick(user.id)
                }},
                    el("img.rounded-circle", { style: "width: 30px; height: 30px; margin-right: 10px;", src: user.imgUrl, onerror: (e: Event) => { (e.target as HTMLImageElement).src = "/public/img/icon200x200.png" } } ),
                    escapeHtml(user.name)
                )
            )
        )
    )
}